import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';
import { BaseNetworkActionValidator } from '../base.network.action.validator';

export class UpdateSecurityServerActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  protected canRunOnCompanionRecords = false;

  private svaAppIds = [
    Constants.Endpoints.APP_IDS.APPID_VMWARE_SERVER,
    Constants.Endpoints.APP_IDS.APPID_SCANDINAVIA_SERVER,
    Constants.Endpoints.APP_IDS.APPID_HVINTRO_SERVER,
    Constants.Endpoints.APP_IDS.APPID_NSVA,
  ];

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (ProtectedEntitiesHelper.isComputer(record)) {
      if (!record.specifics.appId) {
        return false;
      }

      if (this.svaAppIds.indexOf(record.specifics.appId) === -1) {
        return false;
      }
    }

    return true;
  }
}
